module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/badge-01-af58720a36d7329d5884f64adbd04698.png";